import { createSkuRequestRpc, createTrialRequestRpc } from 'growth-monetization-service-types';
import { rpcClient } from '../client';
export const sendRequestTrialNotification = ({
  apiName
}) => rpcClient.call(createTrialRequestRpc, {
  data: {
    apiName
  }
});
export const sendRequestSKUNotification = ({
  apiName
}) => rpcClient.call(createSkuRequestRpc, {
  data: {
    apiName
  }
});